import { defineComponent as r, openBlock as d, createBlock as l, unref as n, mergeProps as o, withCtx as s, renderSlot as p } from "vue";
import u from "./ghl-ui.es172.js";
const f = r({
  name: "UIDrawer",
  inheritAttrs: !1
}), m = r({
  ...f,
  props: {
    show: {
      type: Boolean,
      default: !1
    },
    width: {
      type: Number,
      default: 502
    },
    placement: {
      type: String,
      default: "right"
    },
    id: {
      type: String,
      required: !0
    },
    displayDirective: {
      type: String,
      default: "if"
    }
  },
  emits: ["update:show"],
  setup(e) {
    return (t, i) => (d(), l(n(u), o({ id: e.id }, t.$attrs, {
      show: e.show,
      width: e.width,
      placement: e.placement,
      "onUpdate:show": i[0] || (i[0] = (a) => t.$emit("update:show", a)),
      "display-directive": e.displayDirective
    }), {
      default: s(() => [
        p(t.$slots, "default")
      ]),
      _: 3
    }, 16, ["id", "show", "width", "placement", "display-directive"]));
  }
}), c = m;
export {
  c as default
};
